export default __webpack_public_path__ + "static/media/plan-li-plants.2d281e86.svg";